import TableBox from './TableBox';
export default TableBox;


// WEBPACK FOOTER //
// ./src/components/TableBox/index.js